import { render, staticRenderFns } from "./ChargerLink.vue?vue&type=template&id=117823b2&lang=pug&"
import script from "./ChargerLink.vue?vue&type=script&lang=ts&"
export * from "./ChargerLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports